import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Reveal, Eyebrow, LineReveal } from "./Reveal";
import { CONTACT_EMAIL } from "../../config";

export const PageHeader = ({ eyebrow, lines, intro, testId, children }) => (
  <section className="mx-auto max-w-[1400px] px-6 pb-16 pt-36 sm:px-10 lg:pb-24 lg:pt-48" data-testid={testId}>
    <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
    <LineReveal lines={lines} lastClassName="italic text-[#005F60]" className="f-serif mt-8 text-[clamp(2.8rem,8vw,7rem)] font-normal leading-[0.98] tracking-[-0.02em]" />
    <div className="mt-10 grid gap-10 lg:grid-cols-12">
      <Reveal delay={0.4} className="lg:col-span-6 lg:col-start-7">
        <p className="text-lg leading-relaxed text-[#2E353B]">{intro}</p>
        {children}
      </Reveal>
    </div>
  </section>
);

export const FinalCta = () => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-[#005F60] text-[#FAF8F5]" data-testid="final-cta">
      <div className="absolute -right-24 top-0 h-full w-1/2 bg-[#003E40] [clip-path:polygon(30%_0,100%_0,100%_100%,0_100%)]" aria-hidden="true" />
      <div className="absolute bottom-0 right-[12%] h-24 w-24 bg-[#FFCC00] lg:h-40 lg:w-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-[1400px] px-6 py-24 sm:px-10 lg:py-40">
        <Reveal><Eyebrow light>{t.cta.eyebrow}</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="f-serif mt-8 max-w-4xl text-[clamp(2.6rem,7vw,6.5rem)] leading-[0.98] tracking-[-0.02em]">{t.cta.title}</h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="f-serif mt-6 text-xl italic text-[#E9E4DA] lg:text-2xl">{t.cta.sub}</p>
          <div className="mt-12 flex flex-wrap items-center gap-6">
            <Link to="/contacto" className="btn-light" data-testid="final-cta-btn">
              {t.cta.btn} <ArrowUpRight size={18} />
            </Link>
            <a href={`mailto:${CONTACT_EMAIL}`} className="link-u text-sm" data-testid="final-cta-email">{CONTACT_EMAIL}</a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
